// API 설정
export const CONFIG = {
  // 환경에 따라 API URL 자동 선택
  // 개발: localhost:5000
  // 프로덕션: AWS ALB
  CLOUD_FUNCTION_URL: process.env.REACT_APP_API_URL || "http://localhost:5000",

  // 썸네일 Lazy Loading 설정
  INITIAL_THUMBNAIL_COUNT: parseInt(process.env.REACT_APP_INITIAL_THUMBNAIL_COUNT, 10) || 5
};

// 지원 언어 목록 (번역 기능용)
export const SUPPORTED_LANGUAGES = [
  { code: 'ko', name: '한국어', englishName: 'Korean' },
  { code: 'en', name: '영어', englishName: 'English (US)' },
  { code: 'id', name: '인도네시아어', englishName: 'Indonesian' },
  { code: 'ja', name: '일본어', englishName: 'Japanese' },
  { code: 'zh', name: '중국어', englishName: 'Chinese (Simplified)' },
  { code: 'hi', name: '힌디어', englishName: 'Hindi' },
  { code: 'vi', name: '베트남어', englishName: 'Vietnamese' },
  { code: 'th', name: '태국어', englishName: 'Thai' },
  { code: 'tl', name: '필리핀어', englishName: 'Filipino' },
  { code: 'ne', name: '네팔어', englishName: 'Nepali' },
  { code: 'km', name: '크메르어', englishName: 'Khmer' },
  { code: 'mn', name: '몽골어', englishName: 'Mongolian' },
  { code: 'ru', name: '러시아어', englishName: 'Russian' },
  { code: 'uz', name: '우즈베크어', englishName: 'Uzbek' },
  { code: 'es', name: '스페인어', englishName: 'Spanish' },
  { code: 'ar', name: '아랍어', englishName: 'Arabic' },
  { code: 'fr', name: '프랑스어', englishName: 'French' },
  { code: 'bn', name: '벵골어', englishName: 'Bengali' }
];

// 언어 코드 → 한국어 이름 매핑 (편의용)
export const LANGUAGE_NAMES = SUPPORTED_LANGUAGES.reduce((acc, lang) => {
  acc[lang.code] = lang.name;
  return acc;
}, {});

// 크레딧 예측 계수
export const CREDIT_PREDICTION = {
  TYPO_INDIVIDUAL_RATE: 0.01,  // 개별 오타검사 토큰당 비용 계수
  TYPO_BATCH_RATE: 0.02,       // 전체 오타검사 토큰당 비용 계수
  TRANSLATION_RATE: 0.02,      // 번역 토큰당 비용 계수
  MULTIPLIER: 2                // 예측값 배수
};

// 기존 고정값 (prediction_data 없을 때 fallback)
export const CREDIT_FALLBACK = {
  TYPO_INDIVIDUAL: 50,
  TYPO_BATCH: 200,
  TRANSLATION: 200
};

export default CONFIG;